import React from 'react';
import { HomeWrapper } from '../../src/components/HomePage/HomeBanner/styled';
import GlobalStyle from '../../src/styles/globalStyles';
import NewHeader from '../../src/components/HomePage/NewHeader';
import TagListHeader from '../../src/components/TagList/TaglistHeader';
import TagListSection from '../../src/components/TagList/TagListSection';
import NewFooter from '../../src/components/HomePage/NewFooter';
import { getAllParentTags } from '../../src/datafetchers/TagList';
import { NextSeo } from 'next-seo';
import { tagListMetaData } from '../../src/Constants/MetaData';

export async function getStaticProps() {
  const tagsData = await getAllParentTags();
  return {
    props: {
      tagsData,
    },
  };
}

export default function index(props) {
  const { tagsData } = props;
  return (
    <>
      <NextSeo
        noindex={true}
        nofollow={true}
        title={tagListMetaData.metaTitle}
        description={tagListMetaData.metaDescription}
      />
      <GlobalStyle />
      <NewHeader />
      <HomeWrapper>
        <TagListHeader />
        {tagsData?.data?.map((item, index) => {
          if (item.heading === 'All Topics')
            return (
              <TagListSection
                listData={item?.tagsWithId}
                key={`TagListMain${index}`}
              />
            );
        })}
      </HomeWrapper>
      <NewFooter />
    </>
  );
}
